import { render, staticRenderFns } from "./RequestCodeVerify.vue?vue&type=template&id=bdc65c66&"
import script from "./RequestCodeVerify.vue?vue&type=script&lang=js&"
export * from "./RequestCodeVerify.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports